export const SHORT_FIELD_WIDTH = '50%';
